import { render, staticRenderFns } from "./NewPatient.vue?vue&type=template&id=17d00cc1"
import script from "./NewPatient.vue?vue&type=script&lang=js"
export * from "./NewPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports